export default __webpack_public_path__ + "static/media/favicon.ceed9416.ico";